document.addEventListener("DOMContentLoaded", (e) => {
  const variantDiv = document.querySelector(".novCardsCtn");

  const formPrice = document.querySelector(".grid-product__price");

  const plus = document.querySelector(".js-qty__adjust.js-qty__adjust--plus");
  const minus = document.querySelector(".js-qty__adjust.js-qty__adjust--minus");
  const quantity = document.querySelector(".js-qty__wrapper input");

  plus.addEventListener("click", (e) => {
    editPrice(true);
  });
  minus.addEventListener("click", (e) => {
    editPrice(false);
  });

  function editPrice(plus = true) {
    const formatMoney = (value) => {
      const num = Number(value) || 0;
      return num.toFixed(2); // always 2 decimal places
    };

    const data = {
      price: formPrice.getAttribute("data-price-plain"),
      code: formPrice.getAttribute("data-currency-code"),
      discounted: formPrice.getAttribute("data-dp"),
      compare: formPrice.getAttribute("data-compare-plain"),
    };

    const mutation = plus ? 1 : -1;
    const newQty = parseInt(quantity.value, 10);
    if (newQty < 1) return;

    const baseTotal = Number(data.price) * newQty;
    const discountedTotal = data.discounted
      ? Number(data.discounted) * newQty
      : null;
    const compareTotal = data.compare ? Number(data.compare) * newQty : null;

    if (discountedTotal !== null) {
      formPrice.innerHTML = `
          <span style="color: #FF7676; text-decoration: line-through; display: block;">
            ${formatMoney(baseTotal)} ${data.code}
          </span>
          ${formatMoney(discountedTotal)} ${data.code}
        `;
    } else if (compareTotal !== null && compareTotal > baseTotal) {
      formPrice.innerHTML = `
          <span style="color: #767676; text-decoration: line-through; display: block;">
            ${formatMoney(compareTotal)} ${data.code}
          </span>
          ${formatMoney(baseTotal)} ${data.code}
        `;
    } else {
      formPrice.innerHTML = `${formatMoney(baseTotal)} ${data.code}`;
    }
  }

  //   variantSelected.addEventListener("click", (e) => {
  //     variantAbsolute.classList.toggle("active");
  //   });
});
